import { memo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box, CircularProgress } from "@mui/material";
import Sortable from "sortablejs";

import { newTicketsUseStyles } from "../../NewTickets";
import { IState } from "../../../../../../redux/reducers/rootReducers";
import CustomCard1 from "../../../../../common/customCard1";
import LoadMoreNewToMe from "../../LoadMore/LoadMoreNewToMe";

const PAGE_SIZE = 20;

const NewToMeTicketsList = memo(({ AllTickets = [] }: any) => {
  const classes = newTicketsUseStyles();
  const FiltersVal: any = useSelector((state: IState) => state?.filtersTicketManagementReducer);
  const shrinkGroupsVal: any = useSelector(
    (state: IState) =>
      state?.LayoutTicketManagementReducer?.groupShrinked
  );

  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  useEffect(() => {
    const ticketList: any = document.getElementById(
      "newtoMeTicketsHodler"
    );

    if (!ticketList) return;

    const sortable = Sortable.create(ticketList, {
      group: {
        name: "list",
        put: false,
        pull: "clone",
      },
      onStart: function () {
        document.documentElement.classList.add(
          "newToMeItemDragged"
        );
      },
      onEnd: function () {
        document.documentElement.classList.remove(
          "newToMeItemDragged"
        );
      },
    });

    // return () => {
    //   sortable?.destroy();
    // };
  }, []);
    useEffect(() => {
      setVisibleCount(PAGE_SIZE);
      setIsLoadingMore(false);
    }, [FiltersVal]);
  useEffect(() => {
  setVisibleCount(prev => {
    const next =
      prev === 0 ? PAGE_SIZE : Math.min(prev, AllTickets.length);

    return prev === next ? prev : next;
  });

  setIsLoadingMore(prev => (prev ? false : prev));
}, [AllTickets]);

  const handleScroll = (e: any) => {
    const { scrollTop, clientHeight, scrollHeight } =
      e.currentTarget;

    const reachedBottom =
      scrollTop + clientHeight >= scrollHeight - 100;

    if (
      reachedBottom &&
      visibleCount < AllTickets.length &&
      !isLoadingMore
    ) {
      setIsLoadingMore(true);

      setTimeout(() => {
        setVisibleCount((prev) =>
          Math.min(prev + PAGE_SIZE, AllTickets.length)
        );

        setIsLoadingMore(false);
      }, 300);
    }
  };

  return (
    <Box
      id="newtoMeTicketsHodler"
      className={`${classes.row} ${classes.flxWrap}`}
      onScroll={handleScroll}
      sx={{
        overflowY: "auto",
        height: "100%",
      }}
    >
      {AllTickets
        ?.slice(0, visibleCount)
        .map((i: any, index: number) => (
          <div
            key={i.id || index}
            className={`${
              shrinkGroupsVal ? "col-3" : "col-6"
            } p-2p userItem newTicketsTiles`}
            data-ticket-id={i.id}
            ticket-id={i.id}
            data-mytickets={"myTickets"}
            data-new-tickets={true}
            data-ticket-priority={i.ticketLogs.priorityId}
            data-ticket-status={i.ticketLogs.statusId}
            data-ticket-ownerid={i.ticketLogs.agentId}
          >
            <CustomCard1
              sourceCode={i?.sourceCode}
              id={i.id}
              ticket={i.ticketLogs}
            />
          </div>
        ))}

      {isLoadingMore && (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            py: 2,
          }}
        >
          <CircularProgress size={24} />
        </Box>
      )}

      {!isLoadingMore &&
        visibleCount >= AllTickets.length &&
        AllTickets.length > 0 && (
          <LoadMoreNewToMe />
        )}
    </Box>
  );
});

export default NewToMeTicketsList;